import Section from './Section';
import styled from 'styled-components';

const StyledSection = styled(Section)`
    ${(props) =>
        props.type && props.theme.sections.types[props.type]
            ? props.theme.sections.types[props.type]
            : props.theme.sections.types.default};
    padding: ${(props) =>
        props.padding &&
        `${props.theme.sections.padding[props.padding]} ${
            props.theme.spacing.md
        }`};
    padding-bottom: ${(props) =>
        props.paddingBottom &&
        props.theme.sections.padding[props.paddingBottom]};
    padding-top: ${(props) =>
        props.paddingTop && props.theme.sections.padding[props.paddingTop]};
`;

export default StyledSection;
